module.exports = __webpack_public_path__ + "static/media/hallstatt-austria.ee6df9dc.jpg";